/* =============================================================
   OceanBox — Curated Boxes Premium JS
   Multi-select filter bar (OR logic) + Custom Quick View Modal
   ============================================================= */

(function () {
  'use strict';

  const DEBUG = false;
  function log(...args) { if (DEBUG) console.log('[CB]', ...args); }

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.from((root || document).querySelectorAll(sel)); }

  // =========================================================
  // MULTI-SELECT FILTER BAR
  // =========================================================
  const activeTags = new Set();

  function filterProducts() {
    const items = $$('.block__main-collection-grid .grid__item');
    items.forEach(item => {
      if (activeTags.size === 0) {
        item.style.removeProperty('display');
        return;
      }
      const tags = (item.querySelector('[data-product-tags]')?.getAttribute('data-product-tags') || item.getAttribute('data-product-tags') || '').toLowerCase().split(',').map(t => t.trim());
      const matches = [...activeTags].some(tag => tags.includes(tag));
      item.style.display = matches ? '' : 'none';
    });
  }

  function updateTabStates() {
    $$('.cb-filter-tab').forEach(tab => {
      const tag = tab.getAttribute('data-tag');
      if (tag === 'all') {
        tab.classList.toggle('active', activeTags.size === 0);
      } else {
        tab.classList.toggle('active', activeTags.has(tag));
      }
    });
  }

  function setupFilters() {
    const tabs = $$('#cb-filter-tabs .cb-filter-tab');
    if (!tabs.length) return;
    tabs.forEach(btn => {
      btn.addEventListener('click', () => {
        const tag = btn.getAttribute('data-tag');
        if (tag === 'all') {
          activeTags.clear();
        } else {
          if (activeTags.has(tag)) activeTags.delete(tag);
          else activeTags.add(tag);
        }
        updateTabStates();
        filterProducts();
      });
    });
  }

  // =========================================================
  // PRODUCT PAGE CACHE
  // =========================================================
  const productCache = new Map();

  function fetchAndProcess(url) {
    return fetch(url)
      .then(r => r.text())
      .then(html => {
        const processed = processHTML(html, url);
        productCache.set(url, processed);
        return processed;
      });
  }

  function setupPrefetchObserver() {
    $$('.block__main-collection-grid [data-product-url]').forEach(btn => {
      const url = btn.getAttribute('data-product-url');
      if (!url) return;

      const prefetch = () => {
        if (!productCache.has(url)) {
          fetchAndProcess(url).catch(() => productCache.delete(url));
        }
      };

      btn.addEventListener('pointerenter', prefetch, { passive: true, once: true });
      btn.addEventListener('touchstart', prefetch, { passive: true, once: true });
    });
  }

  // =========================================================
  // CUSTOM MODAL INJECTION & LOGIC
  // =========================================================
  function injectModalContainer() {
    if (document.getElementById('cb-custom-modal')) return;
    const html = `
      <div id="cb-custom-modal-overlay"></div>
      <div id="cb-custom-modal" role="dialog" aria-modal="true">
        <button id="cb-custom-modal-close" class="cb-modal-close" type="button" aria-label="Close">
          <svg viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="18" cy="18" r="18" />
            <line x1="12" y1="12" x2="24" y2="24" stroke-width="2" />
            <line x1="24" y1="12" x2="12" y2="24" stroke-width="2" />
          </svg>
        </button>
        <div id="cb-custom-modal-body" class="cb-modal-body">
          <div class="cb-loading-spinner"></div>
          <div id="cb-custom-modal-content" class="cb-modal-content"></div>
        </div>
      </div>
    `;
    document.body.insertAdjacentHTML('beforeend', html);

    document.getElementById('cb-custom-modal-close').addEventListener('click', closeCustomModal);
    document.getElementById('cb-custom-modal-overlay').addEventListener('click', closeCustomModal);
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape') closeCustomModal();
    });
  }

  function closeCustomModal() {
    const modal = document.getElementById('cb-custom-modal');
    const overlay = document.getElementById('cb-custom-modal-overlay');
    if (modal) modal.classList.remove('cb-is-visible');
    if (overlay) overlay.classList.remove('cb-is-visible');
    document.body.style.overflow = '';
    document.body.style.position = '';
    document.body.style.width = '';
    const content = document.getElementById('cb-custom-modal-content');
    if (content) content.innerHTML = '';
  }

  function openCustomModal(url) {
    injectModalContainer();
    const modal = document.getElementById('cb-custom-modal');
    const overlay = document.getElementById('cb-custom-modal-overlay');
    const content = document.getElementById('cb-custom-modal-content');
    const spinner = modal.querySelector('.cb-loading-spinner');

    modal.classList.add('cb-is-visible');
    overlay.classList.add('cb-is-visible');
    document.body.style.overflow = 'hidden';

    content.innerHTML = '';
    spinner.style.display = 'block';
    modal.querySelector('.cb-modal-body').classList.add('cb-loading');

    const cached = productCache.get(url);
    if (typeof cached === 'string') {
      // Already processed — render instantly
      renderProcessed(cached, url);
    } else {
      // Not ready — fetch now, render when done
      fetchAndProcess(url)
        .then(processed => renderProcessed(processed, url))
        .catch(() => closeCustomModal());
    }
  }

  // =========================================================
  // RENDER MODAL — injects pre-processed HTML instantly
  // =========================================================
  function renderProcessed(html, productUrl) {
    const content = document.getElementById('cb-custom-modal-content');
    const spinner = document.querySelector('#cb-custom-modal .cb-loading-spinner');
    if (spinner) spinner.style.display = 'none';
    const body = document.querySelector('#cb-custom-modal .cb-modal-body');
    if (body) body.classList.remove('cb-loading');

    content.innerHTML = html;

    // --- Activate scripts for Recharge ---
    content.querySelectorAll('script').forEach(oldScript => {
      const newScript = document.createElement('script');
      Array.from(oldScript.attributes).forEach(attr => newScript.setAttribute(attr.name, attr.value));
      newScript.appendChild(document.createTextNode(oldScript.innerHTML));
      oldScript.parentNode.replaceChild(newScript, oldScript);
    });

    // --- Setup image carousel ---
    const gallery = content.querySelector('.cb-gallery');
    if (gallery && gallery.querySelectorAll('.cb-slide').length > 1) {
      setupCarousel(gallery);
    }
  }

  // =========================================================
  // PROCESS HTML — extracts clean HTML string in background
  // =========================================================
  function processHTML(html, productUrl) {

    const doc = new DOMParser().parseFromString(html, 'text/html');

    // --- Extract images ---
    const images = [];
    doc.querySelectorAll('.product__media-item img').forEach(img => {
      // Get the best src — prefer srcset or src
      const src = img.getAttribute('src') || '';
      const srcset = img.getAttribute('srcset') || '';
      const alt = img.getAttribute('alt') || '';
      if (src || srcset) {
        images.push({ src, srcset, alt });
      }
    });

    // Fallback: if no images found via .product__media-item, try any product image
    if (images.length === 0) {
      doc.querySelectorAll('.product__media-wrapper img').forEach(img => {
        const src = img.getAttribute('src') || '';
        const alt = img.getAttribute('alt') || '';
        if (src) images.push({ src, srcset: '', alt });
      });
    }

    // --- Extract product info ---
    const infoWrapper = doc.querySelector('.product__info-wrapper');

    // --- Build clean modal HTML ---
    let imagesHTML = '';
    if (images.length > 0) {
      // Preload the first image in the background so it's instantly cached
      const preload = new Image();
      if (images[0].srcset) preload.srcset = images[0].srcset;
      preload.src = images[0].src;

      const slidesHTML = images.map((img, i) => {
        const srcsetAttr = img.srcset ? ` srcset="${img.srcset}"` : '';
        const loadingAttr = i === 0 ? '' : ' loading="lazy"';
        return `<div class="cb-slide${i === 0 ? ' cb-slide-active' : ''}">
          <img src="${img.src}"${srcsetAttr} alt="${img.alt}"${loadingAttr}>
        </div>`;
      }).join('');

      // Dot indicators
      const dotsHTML = images.length > 1
        ? `<div class="cb-dots">${images.map((_, i) => 
            `<button class="cb-dot${i === 0 ? ' cb-dot-active' : ''}" data-index="${i}" aria-label="Image ${i + 1}"></button>`
          ).join('')}</div>`
        : '';

      // Arrows
      const arrowsHTML = images.length > 1
        ? `<button class="cb-arrow cb-arrow-prev" aria-label="Previous image">
            <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><polyline points="15 18 9 12 15 6"></polyline></svg>
          </button>
          <button class="cb-arrow cb-arrow-next" aria-label="Next image">
            <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><polyline points="9 18 15 12 9 6"></polyline></svg>
          </button>`
        : '';

      imagesHTML = `<div class="cb-gallery">${slidesHTML}${arrowsHTML}${dotsHTML}</div>`;
    }

    let infoHTML = '';
    if (infoWrapper) {
      // Remove elements we don't want
      const clone = infoWrapper.cloneNode(true);
      // Remove description, list-slider, and accordions
      clone.querySelectorAll('.product__description, .quick-add-hidden, .block__list-slider, .accordion, .product__accordion, .icon-with-text, .you-may-also, [id^="you-may-also"]').forEach(el => el.remove());
      // Remove any "View full details" links
      clone.querySelectorAll('a[href*="/products/"]').forEach(a => {
        if (a.textContent.toLowerCase().includes('view full details')) a.remove();
      });
      // Remove Shopify dynamic checkout buttons
      clone.querySelectorAll('.shopify-payment-button').forEach(el => el.remove());
      
      infoHTML = `<div class="cb-info">${clone.innerHTML}<a href="${productUrl || '#'}" class="cb-view-details">View Full Details</a></div>`;
    }

    return `<div class="cb-layout">${imagesHTML}${infoHTML}</div>`;
  }

  // =========================================================
  // LIGHTWEIGHT IMAGE CAROUSEL (no Swiper dependency)
  // =========================================================
  function setupCarousel(gallery) {
    if (!gallery) return;

    const slides = Array.from(gallery.querySelectorAll('.cb-slide'));
    const dots = Array.from(gallery.querySelectorAll('.cb-dot'));
    const prevBtn = gallery.querySelector('.cb-arrow-prev');
    const nextBtn = gallery.querySelector('.cb-arrow-next');
    let current = 0;

    function goTo(index) {
      if (index < 0) index = slides.length - 1;
      if (index >= slides.length) index = 0;

      slides[current].classList.remove('cb-slide-active');
      dots[current]?.classList.remove('cb-dot-active');

      current = index;

      slides[current].classList.add('cb-slide-active');
      dots[current]?.classList.add('cb-dot-active');
    }

    if (prevBtn) prevBtn.addEventListener('click', e => { e.stopPropagation(); goTo(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', e => { e.stopPropagation(); goTo(current + 1); });
    dots.forEach(dot => {
      dot.addEventListener('click', e => {
        e.stopPropagation();
        goTo(parseInt(dot.dataset.index, 10));
      });
    });

    // Touch/swipe support
    let startX = 0, startY = 0, dragging = false;
    gallery.addEventListener('touchstart', e => {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      dragging = true;
    }, { passive: true });

    gallery.addEventListener('touchend', e => {
      if (!dragging) return;
      dragging = false;
      const dx = e.changedTouches[0].clientX - startX;
      const dy = e.changedTouches[0].clientY - startY;
      // Only trigger horizontal swipe if it's more horizontal than vertical
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
        if (dx < 0) goTo(current + 1);
        else goTo(current - 1);
      }
    }, { passive: true });
  }

  // =========================================================
  // CLICK INTERCEPTION
  // =========================================================
  function setupClickListener() {
    const grid = document.querySelector('.block__main-collection-grid');
    if (!grid) return;

    grid.addEventListener('click', e => {
      const btn = e.target.closest('[data-product-url]');
      if (!btn) return;

      e.preventDefault();
      e.stopPropagation();
      
      const url = btn.getAttribute('data-product-url');
      if (url) {
        openCustomModal(url);
      }
    }, true);
  }

  // Intercept clicks on swiper arrows so they don't trigger the parent <a> tag
  function setupCardArrows() {
    const grid = document.querySelector('.block__main-collection-grid');
    if (!grid) return;
    
    grid.addEventListener('click', (e) => {
      const arrow = e.target.closest('.swiper-button-col');
      if (arrow) {
        e.preventDefault();
        e.stopPropagation();
        
        const swiperContainer = arrow.closest('.swiper-container');
        if (swiperContainer && swiperContainer.swiper) {
          if (arrow.classList.contains('swiper-col-next') || arrow.classList.contains('swiper-button-next-col')) {
            swiperContainer.swiper.slideNext();
          } else {
            swiperContainer.swiper.slidePrev();
          }
        }
      }
    }, true);
  }

  // =========================================================
  // BOOT
  // =========================================================
  function boot() {
    if (!document.querySelector('.block__main-collection-grid')) return;
    
    injectModalContainer();
    setupFilters();
    setupCardArrows();
    setupClickListener();
    setupPrefetchObserver();
    
    log('Curated Boxes Premium JS initialized (Custom Modal Mode)');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
